// extracted by mini-css-extract-plugin
module.exports = {"LandingMenu":"LandingMenu__LandingMenu___3Frch","LogoWrapper":"LandingMenu__LogoWrapper___11wnj"};